module.exports = __webpack_public_path__ + "fonts/F37GingerPro-Bold.3c45ca6.woff2";